// extracted by mini-css-extract-plugin
export default {"dropdown":"_2UCj2UnzvYPJbkYtPtMOzt","menu":"_3QEEhrCHgsWb7zyB-Q-3hH"};